/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./item-modular.vue?vue&type=template&id=6421a491&scoped=true&"
import script from "./item-modular.vue?vue&type=script&lang=ts&"
export * from "./item-modular.vue?vue&type=script&lang=ts&"
import style0 from "./item-modular.vue?vue&type=style&index=0&id=6421a491&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6421a491",
  null
  
)

export default component.exports